import React, { FC } from 'react';
import styles from './MissingChargeAlertDialog.module.scss';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";

interface MissingChargeAlertDialogProps {
    header?: string,
    showCurrentDialog: boolean;
    setShowCurrentDialog: Function;
    setShowNextDialog: Function;
    missingChargeProductName?: string;
    missingChargeElements: string[];
}

const MissingChargeAlertDialog: FC<MissingChargeAlertDialogProps> = ({
         header = '',
         showCurrentDialog,
         setShowCurrentDialog,
         setShowNextDialog,
         missingChargeProductName,
         missingChargeElements
    }) => {
    const headerMessage = (
        <div className={styles.dialogHeader}>
            <i className={`pi pi-exclamation-circle ${styles.warningIcon}`} />
            <span>{header}</span>
        </div>
    );
    const footer = (
        <div>
            <Button label="Go Back" className={"p-button-outlined  p-button-secondary"} onClick={() => setShowCurrentDialog(false)} />
            <Button label="Ignore & Continue" className={styles.btnApproval} onClick={() => {setShowCurrentDialog(false);setShowNextDialog(true);}} />
        </div>
    );
    return (
        <div className={styles.missingChargeAlertDialog} data-testid="MissingChargeAlertDialog">
            <Dialog header={headerMessage} footer={footer} visible={showCurrentDialog} onHide={() => setShowCurrentDialog(false)}>
                <div className={styles.dialogContent}>
                    <div className={styles.warningHeader}>
                        <span>The product setup of the following options have no charge code assigned. This will lead to revenue loss in a quote when selected. Please rectify before activation:</span>
                    </div>
                    {
                        missingChargeProductName &&
                        <div>
                            <div className={styles.section}>Product</div>
                            <ul className={styles.missingProduct}>
                                <li key={missingChargeProductName}>{missingChargeProductName}</li>
                            </ul>
                        </div>
                    }
                    {
                        missingChargeElements.length > 0 &&
                        <div>
                            <div className={styles.section}>Configurations</div>
                            <ul className={styles.missingList}>
                                {missingChargeElements.map(name => (
                                    <li key={name}>{name}</li>
                                ))}
                            </ul>
                        </div>
                    }
                </div>
            </Dialog>
        </div>
    )
};

export default MissingChargeAlertDialog;
